var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1360 -84)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1370.162 92.271 4.923-5.982h-12.696l4.975 5.982a.83.83 0 0 1 .155.465v5.363l2.436 1.186v-6.6c0-.156.103-.31.207-.414Zm6.84-6.188-5.7 6.859v7.375c0 .515-.518.825-.933.618l-3.783-1.805c-.207-.103-.414-.309-.414-.618v-5.57l-5.7-6.859c-.363-.413-.052-1.083.518-1.083h15.494c.57 0 .88.619.518 1.083Z",
    fill: "#1C4566",
    fillRule: "nonzero",
    stroke: "#1C4566",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "red",
    cx: 1376.5,
    cy: 95.5,
    r: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOn);
export default __webpack_public_path__ + "static/media/icon_filter_on.1395eaf57a1814dfb473293fe465d2fd.svg";
export { ForwardRef as ReactComponent };